import React from 'react';
import './PasswordVerify.scss';
import { ProsperoLogo } from 'components/Icons';
import { Button, Form, Image, Input, Row } from 'antd';
import { useMutation, useQuery } from '@apollo/client';
import { VERIFY_PROPOSAL_PASSWORD } from 'graphql/mutations/proposalMutation';
import Cookies from 'js-cookie';
import { GET_BRANDING_DETAIL } from 'graphql/queries/proposalQueries';
import images from 'constants/images';

const PasswordVerify = ({ params }) => {
  const [error, setError] = React.useState(null);
  const { data: { fetchBranding: branding } = {}, loading: brandLoading } = useQuery(
    GET_BRANDING_DETAIL,
    {
      variables: {
        pid: params?.cid,
      },
    }
  );
  const [verifyPassword, { loading }] = useMutation(VERIFY_PROPOSAL_PASSWORD, {
    onCompleted: (data) => {
      if (data.verifyProposalPassword) {
        if (!data?.verifyProposalPassword?.token) {
          setError('Incorrect password. Please try again.');
        } else {
          Cookies.set(params?.cid, data?.verifyProposalPassword?.token, {
            expires: 7,
          });
          window.location.reload();
        }
      } else {
        setError('Incorrect password, please do something');
      }
    },
  });

  const onSubmit = (values) => {
    verifyPassword({
      variables: {
        password: values.password,
        pid: params?.cid,
      },
    });
  };
  return (
    <div className="password-verify-box-wrapper">
      <Form onFinish={onSubmit} onValuesChange={() => setError(null)}>
        <div className="password-verify-box">
          <div className="chatway-brand-icon">
            {!brandLoading && (
              <Image preview={false} src={branding?.logo || images.LOGO_SMALL} alt="logo" />
            )}
            {/* {branding?.companyName && <span className="chatway-brand-txt">{branding?.companyName}</span>} */}
          </div>
          <span className="password-verify-info-note">
            Your proposal is ready! Enter your password to access it securely.
          </span>
          <div className="password-verify-input-box">
            <span className="password-label">Password</span>
            <Form.Item
              name="password"
              rules={[{ required: true, message: 'Please input your password!' }]}>
              <Input.Password
                className={`password-verify-input ${error ? 'input-error' : ''}`}
                placeholder="********"
                visibilityToggle
              />
            </Form.Item>
            {error && <span className="error-text">{error}</span>}
          </div>
          <Button htmlType="submit" loading={loading} className="password-verify-btn">
            OPEN PROPOSAL
          </Button>
        </div>
      </Form>
      <Row className="power-by-section">
        <span className="power-by-text">Powered by</span>
        <ProsperoLogo />
      </Row>
    </div>
  );
};

export default PasswordVerify;
